'use client';

import { redirect, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useSession } from '~/shared/lib/auth';

export default function AuthClientLayout({ children }: React.PropsWithChildren) {
    const { data: session, isPending } = useSession();
    const params = useSearchParams();
    const to = params.get('redirect') ?? '/';

    useEffect(() => {
        if (session) {
            redirect(to);
        }
    }, [session, to]);

    if (isPending) return null;

    return children;
}
